export default "__VITE_ASSET__BDyDF8QO__"